import * as stylex from '@stylexjs/stylex';
import type { VarGroup } from '@stylexjs/stylex/lib/StyleXTypes';
export type TTypographyDesktop = Readonly<{
  fontWeighRegular: string;
  fontWeighDemi: string;
  fontWeighBold: string;
  'fontSizeCaption-3': string;
  'fontSizeCaption-2': string;
  'fontSizeCaption-1': string;
  'fontSizeBody-5': string;
  'fontSizeBody-4': string;
  'fontSizeBody-3': string;
  'fontSizeBody-2': string;
  'fontSizeBody-1': string;
  'fontSizeHeading-4': string;
  'fontSizeHeading-3': string;
  'fontSizeHeading-2': string;
  'fontSizeHeading-1': string;
  'fontSizeDisplay-4': string;
  'fontSizeDisplay-3': string;
  'fontSizeDisplay-2': string;
  'fontSizeDisplay-1': string;
  'lineHeightCaption-2': string;
  'lineHeightCaption-1': string;
  'lineHeightBody-5': string;
  'lineHeightBody-4': string;
  'lineHeightBody-3': string;
  'lineHeightBody-2': string;
  'lineHeightBody-1': string;
}>;
export const typographyDesktop: VarGroup<TTypographyDesktop> = stylex.defineVars({
  fontWeighRegular: '400',
  fontWeighDemi: '600',
  fontWeighBold: '700',
  'fontSizeCaption-3': '10px',
  'fontSizeCaption-2': '12px',
  'fontSizeCaption-1': '14px',
  'fontSizeBody-5': '16px',
  'fontSizeBody-4': '12px',
  'fontSizeBody-3': '18px',
  'fontSizeBody-2': '20px',
  'fontSizeBody-1': '24px',
  'fontSizeHeading-4': '24px',
  'fontSizeHeading-3': '28px',
  'fontSizeHeading-2': '32px',
  'fontSizeHeading-1': '36px',
  'fontSizeDisplay-4': '44px',
  'fontSizeDisplay-3': '52px',
  'fontSizeDisplay-2': '64px',
  'fontSizeDisplay-1': '80px',
  'lineHeightCaption-2': '16px',
  'lineHeightCaption-1': '20px',
  'lineHeightBody-5': '16px',
  'lineHeightBody-4': '24px',
  'lineHeightBody-3': '24px',
  'lineHeightBody-2': '28px',
  'lineHeightBody-1': '32px',
});
